const selectors = {
  header: '[data-section-header-careers]',
  stickyFooter: '[data-job-post-sticky-footer]',
};

const classes = {
  hide: 'hide',
};

export { selectors, classes };
